/* Component Dependencies */
var missingStayFormTemplate = require('templates/missingStayForm.hbs');
var missingStayFormPrintTemplate = require('templates/missingStayForm-print.hbs');
var AriesComponent = require('libs/aries-component');
var DateHandler = require('libs/date-handler');
var Popup = require('libs/popup');
var validator = require('validator');
var FileUploadValidator = require('utils/fileUploadValidator.js');
var emailValidationHandler = require('utils/emailValidation.js');
var ResponsiveUtils = require('utils/responsiveUtils');
var AutoCompleteHandler = require('libs/auto-complete-handler');
var ScrollBarHandler = require('libs/scrollbar');

AriesComponent.create({
  type: 'missingStayForm',
  template: {
    'missingStayForm': missingStayFormTemplate,
    'missingStayForm-print': missingStayFormPrintTemplate
  },
  options:{
    'scrollBarTarget' : '.autocomplete-scroller-wrapper'
  },
  events: {
    'click .js-bill-options-container input': 'changeSubmitSection',
    'click .js-paper-bill-options input': 'showPaperBillViewSubsections',
    'click .js-toggle-hotel-fields-link': 'toggleHotelFields',
    'click .js-icon-calendar': 'showCalendar',
    'click .js-generate-printable-form': 'generatePrintableForm',
    'click .js-btn-submit': 'validationEmail',
    'click .js-third-party-container input': 'toggleForm',
    'keydown .js-name-missing': 'showFolioStayOptions',
    'change .js-folio-stay-pay-container input': 'toggleFolioStay',
    'change .js-comment-area': 'syncTextArea'
  },
  bindEvents: function () {
    this.initResponsiveUtils();
    this.initAutoCompleteHandler();
    this.initScroller();
    // Configuration defining which sections to be shown and hidden for different bill types
    this.sections = {
      DIGITAL_BILL: {
        visibleSections: '.js-digital-bill-section,.js-submit-button-container',
        hiddenSections: '.js-paper-bill-section,.js-no-bill-section'
      },
      PAPER_BILL: {
        visibleSections: '.js-paper-bill-section',
        hiddenSections: '.js-digital-bill-section,.js-no-bill-section,.js-submit-button-container,.js-attach-paper-bill-section,.js-mail-paper-bill-section'
      },
      NO_BILL: {
        visibleSections: '.js-no-bill-section',
        hiddenSections: '.js-digital-bill-section,.js-paper-bill-section,.js-submit-button-container'
      },
      ATTACH_PAPER_BILL: {
        visibleSections: '.js-attach-paper-bill-section,.js-submit-button-container',
        hiddenSections: '.js-mail-paper-bill-section'
      },
      MAIL_PAPER_BILL: {
        visibleSections: '.js-mail-paper-bill-section',
        hiddenSections: '.js-attach-paper-bill-section,.js-submit-button-container'
      }
    };

    // Initialising modals
    var missingStayPopup = new Popup({
      selector: '.tile-missing-stay .mi-popover, .tile-missing-stay-form-print .mi-popover',
      sourceBlock: '.modal-content',
      alternateCloseMarkup: true
    });
    missingStayPopup.register();

    // Caching of dom element
    this.$submitRequestContainer = this.$el.find('.js-submit-request-container');

    // Calling function to intialise date picker
    this.initDateHandler();

    // Setting readonly attribute added by calendar plugin to false and setting focus again on
    // input field which was removed by the plugin so that NVDA voices correctly
    this.$el.find('.js-date-from')
      .prop('readonly', false)
      .on('click focus',function(){$(this).focus();});

    this.isHotelInfoVisible = false;
    this.isMailPaperBillVisible = false;

    FileUploadValidator.initialize(this.$el);
    $('#confirmation-number, #checkin-date, #checkout-date, .js-search-location').prop("disabled", true);

    this.$el.find('.m-missing-stay-form').submit(this.formSubmissionHandler.bind(this));
  	
    if(this.$el.find('.js-bill-options-container input[type=radio]:checked')){
      this.$el.find('.js-bill-options-container input[type=radio]:checked').trigger('click');
    }
    else {
      $('#digital-bill, #paper-bill, #no-bill').prop("disabled", true);
    }
    this.$el.find(".js-third-party-container input[type='radio']:checked").trigger('click');
    this.$el.find('.js-folio-stay-pay-container input[type=radio]:checked, .js-third-party-container input[type=radio]:checked').trigger('change');
    this.disableTextArea();
    $('.l-comment-section .js-comment-area').prop("disabled", true);
  },
  
  initResponsiveUtils: function() {
    this.responsiveUtils = ResponsiveUtils.create({});
    this.responsiveUtils.init();
  },

  /**
+  * This function is use to initialize auto suggest plugin on target elements
+  */
  initAutoCompleteHandler:  function _initAutoCompleteHandler() {
    var autoSuggestSelector = '.js-auto-complete';
    if(this.$el.find(autoSuggestSelector).length) {
      this.autoCompleteHandler = AutoCompleteHandler.create({
        $el: this.$el.find(autoSuggestSelector),
        $parent: this,
        onListClose: function() {
          if(this.$input.val()) {
            this.listItemSelect();  
          }
        }
      });
      this.autoCompleteHandler.init(); 
    }
  },
  /**
  * This function is use to initialize scroller plugin on target elements
  */
  initScroller: function(){
    var scrollBarHandler = ScrollBarHandler.create({
      $el: this.$el,
      $scrollBarTarget: this.$el.find(this.options.scrollBarTarget).not('.custom-wrapper')
    });
    scrollBarHandler.init();
  },

  /**
  * This function is use to toggle between the options of folio and stay
  */
  toggleFolioStay: function _toggleFolioStay() {
    var _self = this,
      commentLabel = _self.$el.find(".js-comment-label"),
      label = commentLabel.data('label'),
      optionalLabel = commentLabel.data('optional-label'),
      errorArea = _self.$el.find('.l-folio-stay-pay-error'),
      yesLabel = _self.$el.data('options')['yesLabel'];

    if(_self.$el.find(".js-folio-stay-pay-container input[type='radio']:checked").val() === yesLabel) {
      errorArea.hide();
      commentLabel.html(label + ' ' + optionalLabel);
      return true;
    }     
    commentLabel.html(label);
    errorArea.show();
  },

  /**
  * This function is use to show folio stay and pay container
  */
 showFolioStayOptions: function _showFolioStayOptions() {
    this.$el.find(".js-folio-stay-pay-container").show();
    this.$el.find(".search-folio-stay-pay").val(true);
  },

  /**
  * This function is use to sync between all comment box.
  */
  syncTextArea: function _syncTextArea(event) {
    var $target = $(event.target),
    $commentArea = this.$el.find(".js-comment-area")
    $commentArea.val($target.val());
    $commentArea.prop('disabled', true);
    $target.prop('disabled', false);
  },

  /**
  * This function is use to show and hide form for thirdparty booking
  */
  toggleForm: function _toggleForm() {
    var _self = this,
    formArea = _self.$el.find('.l-form-area'),
    stayInformationArea = _self.$el.find('.l-stay-info-section'),
    yesLabel = _self.$el.data('options')['yesLabel'];
    errorArea = _self.$el.find('.l-third-party-error');
    if(_self.$el.find(".js-third-party-container input[type='radio']:checked").val() === yesLabel) {
      formArea.hide();
      errorArea.show();
      stayInformationArea.css({"opacity":"0.3","pointer-events": "none"});
      $('#confirmation-number, #checkin-date, #checkout-date, .js-search-location, #digital-bill, #paper-bill, #no-bill').prop("disabled", true);
      return true;
    } 
    formArea.show();
    stayInformationArea.css({"opacity":"1","pointer-events": "all"});
    $('#confirmation-number, #checkin-date, #checkout-date, .js-search-location, #digital-bill, #paper-bill, #no-bill').prop("disabled", false);
    errorArea.hide(); 
  },

  /**
  * This function is used to initialise date handler library
  * @returns {Object} Current component instance
  */
  initDateHandler: function _initDateHandler() {
    this.calendarState={};
    var _self = this;
    var dateHandler = new DateHandler({
      $el: _self.$el.find('.js-calendar-container'),
      $parent: _self,
      singleDate: true,
      format: _self.$el.find('.js-date-from').data('submission-date-format'),
      bindSingleDateEvents: true
    });
    dateHandler.init();
    _self.calendarState[dateHandler.from.$input.attr('id')] =dateHandler.from.$input.data('pickadate');
    $(dateHandler.from.$input[0]).data('pickadate', dateHandler.from.$input.data('pickadate'));

    var dateHandlerCheckout = new DateHandler({
      $el: _self.$el.find('.js-calendar-container-checkout'),
      $parent: _self,
      singleDate: true,
      format: _self.$el.find('.js-date-from').data('submission-date-format'),
      bindSingleDateEvents: true
    });
    dateHandlerCheckout.init();
    _self.calendarState[dateHandlerCheckout.from.$input.attr('id')]=dateHandlerCheckout.from.$input.data('pickadate');
    $(dateHandlerCheckout.from.$input[0]).data('pickadate', dateHandler.from.$input.data('pickadate'));
    _self.calendarState['checkin-date'].on('set', _self.setMinCheckOutDate.bind(_self))
    return _self;
  },
  /**
  * This function is used to focus on calendar input field to show calendar
  * @param {object} event object
  * @returns {boolean} Return false to stop default event action
  */
  showCalendar:function _showCalendar(event){
    var $input = $(event.target).closest('.m-date-picker').find('.js-date-from');
    $input.focus();
    return false;
  },
  /**
  * This function is used to update submit section according to bill option selected by guest
  * @param {object} event object
  * @returns {boolean} Return true to continue event default action
  */
  changeSubmitSection: function _changeSubmitSection(event) { 
    var $target = $(event.target),
    submitSectionArea = this.$el.find('.l-submit-section');
    submitSectionArea.css({"opacity":"1","pointer-events": "all"});
    if($target.hasClass('js-digital-bill')) {
      this.$el.find(".l-comment-section").hide();
      this.showDigitalBillView();
    } else if($target.hasClass('js-paper-bill')) {
      this.$el.find(".l-comment-section").show();
      this.showPaperBillView();
    } else {
      this.$el.find(".l-comment-section").hide();
      this.showNoBillView();
    }
    this.disableTextArea();
    return true;
  },

  /**
  * This function is used to disable hidden text area and enable view text area
  */
  disableTextArea: function _disableTextArea() {
    this.$el.find(".js-comment-area:visible").prop('disabled', false);
    this.$el.find(".js-comment-area:hidden").prop('disabled', true);
  },

  /**
  * This function is used to update submit section corresponding to digital bill option
  * @returns {Object} Current component instance
  */
  showDigitalBillView: function _showDigitalBillView() {
    var _self = this;
    _self.$submitRequestContainer.addClass('m-submit-digital-copy-section');
    _self.toggleFormSections('DIGITAL_BILL');
    return _self;
  },
  /**
  * This function is used to update submit section corresponding to paper bill option
  * @returns {Object} Current component instance
  */
  showPaperBillView: function _showPaperBillView() {
    var _self = this;
    _self.$submitRequestContainer.removeClass('m-submit-digital-copy-section');

    _self.toggleFormSections('PAPER_BILL');

    this.$el.find('.js-paper-bill-options input[type=radio]:checked').trigger('click');

    return _self;
  },
  /**
  * This function is used to update submit section corresponding to no bill option
  * @returns {Object} Current component instance
  */
  showNoBillView: function _showNoBillView() {
    var _self = this;
    _self.$submitRequestContainer.removeClass('m-submit-digital-copy-section');
    _self.toggleFormSections('NO_BILL');
    return _self;
  },
  /**
  * This function is used to update submit section according to paper bill option selected by guest
  * @param {Event} event object
  * @returns {boolean} Return true to continue event default action
  */
  showPaperBillViewSubsections: function _showPaperBillViewSubsections(event) {
    var $target = $(event.target);
    this.$el.find(".l-comment-section").hide();
    if($target.hasClass('js-attach-bill')) {
      this.showAttachBillView();
    }else {
      this.showMailBillView();
    }
    this.disableTextArea();
    return true;
  },
  /**
  * This function is used to update submit section corresponding to attach a scanned copy or 
  * photograph of paper bill option
  * @returns {Object} Current component instance
  */
  showAttachBillView: function _showAttachBillView() {
    var _self = this;
    _self.toggleFormSections('ATTACH_PAPER_BILL');
    return _self;
  },
  /**
  * This function is used to update submit section corresponding to fax or mail paper bill option
  * @returns {Object} Current component instance
  */
  showMailBillView: function _showMailBillView() {
    var _self = this;
    _self.toggleFormSections('MAIL_PAPER_BILL');
    return _self;
  },
  /**
  * This function is used to toggle hotel input fields
  * @param {Event} event object
  * @returns {boolean} Return false to stop default event action
  */
  toggleHotelFields: function _toggleHotelFields(event) {
    event.preventDefault();
    var $iconElement = this.$el.find('.js-icon-accordion');
    this.$el.find('.js-hotel-info').toggle();
    if($iconElement.hasClass('t-icon-arrow-down')) {
      $iconElement.removeClass('t-icon-arrow-down').addClass('t-icon-arrow-up');
    } else {
      $iconElement.removeClass('t-icon-arrow-up').addClass('t-icon-arrow-down');
    }
    // Re-init selectric dropdown only once on first show of hotel info section
    // to allow it to re-calculate its width
    $(document).trigger('GLOBAL_ELEMENTS_REINIT.mi-select');
    this.isHotelInfoVisible = true;
    return false;
  },
  /**
  * This function is used to show and hide sections corresponding to section name
  * @param {string} Section name
  * @returns {Object} Current component instance
  */
  toggleFormSections: function _toggleFormSections(sectionName) {
    var _self = this;
    var sectionConfigObject = _self.sections[sectionName];
    _self.$el.find(sectionConfigObject.visibleSections).show();
    _self.$el.find(sectionConfigObject.hiddenSections).hide();
    // Re-init selectric dropdown only once on first show of mail paper bill section
    // to allow it to re-calculate its width
    $(document).trigger('GLOBAL_ELEMENTS_REINIT.mi-select');
    this.isMailPaperBillVisible = true;
    return _self;
  },
  /**
  * This function is used to disable the input fields which are not required to be submitted
  * @param {Event} event object
  * @returns {boolean} returns true to continue event default action
  */
  formSubmissionHandler: function _formSubmissionHandler(event) {
    var $digitalBillSection = this.$el.find('.js-digital-bill-section');
    var $paperBillSection = this.$el.find('.js-paper-bill-section');
    if(!$digitalBillSection.is(":visible")) {
      $digitalBillSection.find('.js-attach-bill-section input').prop('disabled', true);
    } else {
      if(!$paperBillSection.is(":visible")) {
        $paperBillSection.find('.js-attach-bill-section input').prop('disabled', true);
      }
    }
    this.$el.find('.js-unformatted-date-checkin').val(this.$el.find('.js-date-checkin').val());
    this.$el.find('.js-unformatted-date-checkout').val(this.$el.find('.js-date-checkout').val());
    if(!this.$el.find('.js-date-checkin').val()) {
      this.$el.find("input[name=checkInEnteredDate]").val('');
    }
    if(!this.$el.find('.js-date-checkout').val()) {
      this.$el.find("input[name=checkOutEnteredDate]").val('');
    }
    if(!this.$el.find('.search-property-name').val()) {
      this.$el.find('.search-property-name').val(this.$el.find(".js-search-location").val());
    }
    if (event.type == 'submit') {
      if (this.$el.find('.js-digital-bill').prop("checked") || (this.$el.find('.js-paper-bill').prop("checked") && this.$el.find('.js-attach-bill').prop("checked"))) {
        return true;
      }else {
        event.preventDefault();
        return false;
      }
    }else {
      if (this.$el.find('.js-digital-bill').prop("checked") || (this.$el.find('.js-paper-bill').prop("checked") && (this.$el.find('.js-attach-bill').prop("checked") || this.$el.find('.js-mail-bill').prop("checked")))) {
        return true;
      }
    }
  },

  /**
  * This function is used to submit form and open print screen in case of success
  * On successful submission a print window opens in new tab/screen
  * On validation error scenria, it refreshes the component itself and message box also.
  * @param {Event} event object
  * @returns {boolean} returns true to continue event default action
  */
  generatePrintableForm: function _generatePrintableForm(event){
    var _self = this;
    var formData = new FormData(_self.$el.find('form')[0]);
    var urlValidationRegex = /^[\/.?=a-zA-Z0-9_-]*$/ig;
    _self.formSubmissionHandler(event);
    _self.makeAjaxCall({
        url: _self.$el.find('form').attr('action'),
        method: 'POST',
        contentType: false,
        processData : false,
        skipRedirect: true,
        data: new FormData(_self.$el.find('form')[0]),
        success: function(response){
          if(response.status==='success'){
            if (validator.matches(response.nextStateURI, urlValidationRegex)) {
              window.open(response.nextStateURI, '_blank', 'width=630,height=500,scrollbars=yes,menubar=no,toolbar=no,status=no,resizable=yes');
            }
            _self.refresh();
            _self.pubsub.publish('REFRESH_MESSAGE_BOX', [response.messageIdentifier]);
          }else if(response.status==='validation_error'){
            if (validator.matches(response.nextStateURI, urlValidationRegex)) {
              window.location.href = response.nextStateURI;
            }
          }
        },
        error: function(errorMsg){}
    });
    return true;
  },

  validationEmail: function _validationEmail(e){
    if(!emailValidationHandler.emailValidation($('.js-emailValidation').val(), 'email')){
      $('#email-validation').removeClass('l-display-none');
						if($('.tile-message-box')) {
									$('.tile-message-box').addClass('l-display-none');
								}
      e.preventDefault();
    }
    else{
        $('#email-validation').addClass('l-display-none');
    }

  },

  setMinCheckOutDate: function _setMinCheckOutDate(data) {
    var checkOut = this.calendarState['checkout-date'];
    var checkOutDate = checkOut.get('select');
    if( checkOutDate && data.select > checkOutDate.pick ) {
      checkOut.set('select');
    }
    var updatedCheckOut = new Date(data.select);
    updatedCheckOut.setDate(updatedCheckOut.getDate() + 1);
    checkOut.set('min', updatedCheckOut);
  }
});